module.exports = __webpack_public_path__ + "static/media/Sampon_na_vlasy_s_CBD_retina.de20c487.jpg";